/**
 * @file Renders the total-amount summary row shown under the beneficiaries table.
 */
import { useMemo } from "react";
import { Table, Typography } from "antd";

import { Value } from "@components/Text";

const { Text } = Typography;
const { Row, Cell } = Table.Summary;

type Props = {
  amountByKey: Record<string, number>;
  selectedRowKeys: string[];
}

/**
 * Renders the total of the amounts of the selected beneficiaries.
 */
const BeneficiariesTableSummary = ({ amountByKey, selectedRowKeys }: Props) => {
  const totalAmount = useMemo(() =>
    selectedRowKeys
      .map(key => amountByKey[key])
      .reduce((sum, value) => sum + (Number(value) || 0), 0)
  , [ amountByKey, selectedRowKeys ]);

  return (
    <Table.Summary>
      <Row>
        <Cell
          index={0}
          align="right"
          colSpan={5}
        >
          <Text strong>Total Amount:</Text>
        </Cell>

        <Cell
          index={5}
          align="left"
        >
          <Value value={totalAmount} />
        </Cell>

        <Cell index={6} />
      </Row>
    </Table.Summary>
  );
};

export default BeneficiariesTableSummary;
